module.exports = __webpack_public_path__ + "7554aafd4386e7b7b33660420e6cfa1c.svg";